import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from 'src/app/config/api.config';
import {
  ApiCertificat,
  ApiCertificatReponse,
  ApprenantJamaisConnecte,
} from '../models/stat-connexion-api.mapper';
import { EnvoiMailPayload } from '../components/envoi-mail-modal/envoi-mail-modal.component';

@Injectable({
  providedIn: 'root',
})
export class RapportService {
  constructor(private httpClient: HttpClient) { }

  getStatConnectionbyCohortandType(
    cohorte: string,
    type: string,
  ): Observable<ApiCertificatReponse> {
    const params = new HttpParams()
      .set('cohort', cohorte)
      .set('typeAppel', type);

    return this.httpClient.get<ApiCertificatReponse>(
      `${config.apiBaseUrl}/trackingMoodle/trackingByCohortAndAppel`,
      { params },
    );
  }
  notifierApprenants(apprenants: ApprenantJamaisConnecte[]): Observable<any> {
    return this.httpClient.post(
      `${config.apiBaseUrl}/trackingMoodle/notifyNeverConnected`,
      apprenants,
    );
  }
  envoyerMailApprenants(payload: EnvoiMailPayload): Observable<void> {
    return this.httpClient.post<void>(
      `${config.apiBaseUrl}/trackingMoodle/notifyExamLearners`,
      payload,
    );
  }

  getSingleCertificateTracking(
    certificateId: string,
    typeAppel: string,
  ): Observable<ApiCertificat> {
    const params = new HttpParams()
      .set('certificateId', certificateId)
      .set('typeAppel', typeAppel);

    return this.httpClient.get<ApiCertificat>(
      `${config.apiBaseUrl}/trackingMoodle/singleCertificateTracking`,
      { params },
    );
  }

  telechargerEmailsEnEchec(certificatId: string): Observable<Blob> {
    return this.httpClient.get(
      `${config.apiBaseUrl}/trackingMoodle/notifyExamLearners/echecs/excel`,
      { params: { certificatId }, responseType: 'blob' },
    );
  }

  getProgression(certificatId: string): Observable<number> {
    return this.httpClient.get<number>(
      `${config.apiBaseUrl}/trackingMoodle/notifyExamLearners/progression`,
      { params: { certificatId } },
    );
  }
}
